import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert} from 'reactstrap';

import Selectors from "~/state/selectors.ts";
import useEffectOnce from "~/hooks/use-effect-once.ts";
import {actions} from "~/state/reducers/worktag-reducer.ts";

function withCommonWorktags<P>(WrappedComponent: React.ComponentType<P>) {
    const WithCommonWorktagsComponent: FC<P> = (props) => {
        const dispatch = useDispatch();
        const metaWorktags = useSelector(Selectors.getMetaWorktags);

        useEffectOnce(() => {
            if (metaWorktags?.fetchingCommonWorktags !== true) {
                dispatch(actions.loadCommonWorktags())
            }
        });

        return (
            <>
                {metaWorktags?.loadedCommonWorktags ? <WrappedComponent {...props}/> :
                    <Alert className="m-4" color="info">Loading...</Alert>}
            </>
        );
    }

    return WithCommonWorktagsComponent;
}

export default withCommonWorktags;
